module.exports = __webpack_public_path__ + "media/images/recruitment/landing/icon_check-a12997540802435b8fa2adba728b449d.svg";